import React from 'react';
import {Outlet} from 'react-router-dom';

const CommunicationExplorerOutlet: React.FC = () => {
  return <Outlet />;
};

export default CommunicationExplorerOutlet;
